<template>
  <section class="item-container">
    <div class="container">
      <!-- <div class="image-container">
        <img
          v-if="product.image"
          class="image"
          :src="product.image"
        />
      </div> -->

      <div class="item-content">
        <div class="price-container">
          <h5 class="name">{{ product.name }}</h5>
          <div class="price-content">
            <a class="price">{{ formatMoney(product.price) }}</a>
          </div>
        </div>
        <table class="table-container">
          <tr>
            <td v-if="product.image" :class="getImageTdContainer">
              <img class="image" :src="product.image" />
            </td>
            <td :class="getDescrTdContainer">
              <span class="description">
                {{ getDescription }}
              </span>
            </td>
            <td class="bandaid-td-container">
              <div v-if="!product.stock || product.stock > 0">
                <BandAid
                  v-if="showBandAid"
                  :quantity="quantity"
                  :stockQuantity="Number(product.stock)"
                  @plusQuantity="innerPlusQuantity(product)"
                  @lessQuantity="innerLessQuantity(product.sku)"
                />
              </div>
              <p v-else class="without-stock">Sin stock</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import BandAid from "./BandAid";
import mobile_detection from "../mixins/mobile_detection";
export default {
  mixins: [mobile_detection],
  name: "productItem",
  props: {
    quantity: {
      type: Number,
      default: () => {
        return {};
      }
    },
    product: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showBandAid: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatMoney(price) {
      return new Intl.NumberFormat("es-ar", {
        style: "currency",
        currency: "ARS"
      }).format(price);
    },
    innerPlusQuantity(prod) {
      this.$emit("plusQuantity", prod);
    },
    innerLessQuantity(sku) {
      this.$emit("lessQuantity", sku);
    }
  },
  data() {
    return {};
  },
  computed: {
    getImageTdContainer() {
      if (this.isMobile()) {
        return "image-td-container-mobile";
      } else {
        return "image-td-container";
      }
    },
    getDescrTdContainer() {
      if (this.isMobile()) {
        return "descr-td-container-mobile";
      } else {
        return "descr-td-container";
      }
    },
    getDescription() {
      if (this.isMobile()) {
        const maxLength = 150;
        if(this.product.description.length < maxLength) return this.product.description;
        else return `${this.product.description.substring(
          0,
          Math.min(maxLength, this.product.description.length)
        )}...`;
      } else {
        return this.product.description;
      }
    }
  },
  components: {
    BandAid
  }
};
</script>

<style scoped>
.image {
  width: auto;
  max-height: 100px;
  float: left;
  margin-right: 0.5em;
}
.table-container {
  width: 100%;
}
.image-td-container {
  width: 8%;
}
.image-td-container-mobile {
  width: 20%;
}
.bandaid-td-container {
  width: 10%;
}
.without-stock {
  color: red;
  font-weight: 800;
  inline-size: max-content;
  float: right;
}
.descr-td-container {
  display: block;
}
.descr-td-container-mobile {
  display: block;
  font-size: 10px;
  line-height: 14px;
}
.container {
  display: inline-flex;
  padding: 0em !important;
}
.item-container {
  padding: 0.2em;
  background: white;
  /* border-radius: 10px; */
  border-bottom: 0.5px solid #ccc;
  /* box-shadow: 1px 1px 10px black; */
  width: 99%;
  /* margin-bottom: 0.1em; */
  display: inline-block;
  -webkit-transition: box-shadow 0.2s ease-in-out;
  transition: box-shadow 0.2s ease-in-out;
}
.image-container {
  align-self: center;
}
.item-content {
  margin: 0px 0px 0px 0px !important;
  padding: 0.2em;
  width: 100%;
  margin-left: 0.5em !important;
}
.name {
  text-align: left;
  font-weight: bold;
  font-size: 1em;
  width: 75%;
}
.description {
  justify-content: left;
  text-align: left;
  float: left;
  display: block;
  padding-right: 0.5em;
}
.price-container {
  display: inline-flex;
  width: 100%;
  padding: 0em !important;
}
.price-content {
  text-align: end;
  width: 25%;
}
.price {
  color: #0D6496 !important;
}
h1,
h2 {
  font-weight: normal;
}
p {
  font-weight: lighter;
  font-size: 0.8em;
  margin: 0em !important;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #0D6496 !important;
}

.bwo-title-inline {
  display: inline;
}

.bwo-menu-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.item-content {
  margin: 20px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/Components/ProductItem.vue